import { slice } from 'ramda';

import { isValidBusinessCaseNumber, isValidCDV as checkCDV } from 'utils';

import {
	isFirstDateGreater,
	regex,
	validFieldAsterisk,
	validFirstThreeLettersOfAsterisk,
} from '../utils/validationHelpers';

export const exactLength =
	({ msg, length }) =>
	({ fieldValue }) => {
		return fieldValue && String(fieldValue).length !== length ? msg : false;
	};

export const decimalLength =
	({ msg, length, wholePartLength = 8 }) =>
	({ fieldValue }) => {
		return fieldValue && !regex(`^(-)?\\d{1,${wholePartLength}}(\\,\\d{1,${length}})?$`)(fieldValue) ? msg : false;
	};

export const hasLengthBetween =
	({ msg, min, max }) =>
	({ fieldValue }) => {
		return fieldValue && (fieldValue.length < min || fieldValue.length > max) ? msg : false;
	};

export const domainMaxLength =
	({ max, msg }) =>
	({ fieldValue }) => {
		const domainFirstIndex = fieldValue.indexOf('@');
		const domainStartCuted = slice(domainFirstIndex + 1, Infinity, fieldValue);
		const domainLastIndex = domainStartCuted.indexOf('.');
		const domain = slice(0, domainLastIndex, domainStartCuted);
		return domain.length <= max ? false : msg;
	};

export const isGreaterThan =
	({ msg, value }) =>
	({ fieldValue }) => {
		return fieldValue && !(fieldValue > value) ? msg : false;
	};

export const isDecimalNumberNotGreaterThan =
	({ msg, value }) =>
	({ fieldValue }) => {
		return fieldValue && !(fieldValue.replace(',', '.') <= value) ? msg : false;
	};

export const notAllowedCharacters =
	({ msg, reg }) =>
	({ fieldValue }) => {
		return fieldValue && regex(reg)(fieldValue) ? true : msg;
	};

export const notAllowedCharactersFromTo =
	({ msg, reg, from, to }) =>
	({ fieldValue }) => {
		const fieldValueFromTo = String(fieldValue).slice(from - 1, to);
		return fieldValueFromTo && regex(reg)(fieldValueFromTo) ? false : msg;
	};

export const allowedLastCharacterNumberOrLetter =
	({ reg, msg, allowedCharacters, lastNum }) =>
	({ fieldValue }) => {
		const fieldValueFromTo = String(fieldValue).slice(lastNum - 1);
		return fieldValueFromTo && (regex(reg)(fieldValueFromTo) || allowedCharacters.includes(fieldValueFromTo))
			? false
			: msg;
	};

export const checkValidBusinessCaseNumber =
	({ msg }) =>
	({ fieldValue }) => {
		return isValidBusinessCaseNumber(fieldValue) ? true : msg;
	};

export const notAllowedAllNulls =
	({ msg }) =>
	({ fieldValue }) => {
		if (isNaN(fieldValue)) {
			return false;
		} else {
			return fieldValue > 0 ? true : msg;
		}
	};

export const not =
	({ msg, reg }) =>
	({ fieldValue }) => {
		return fieldValue && !regex(reg)(fieldValue) ? msg : false;
	};

export const asteriskLimit =
	({ msg, max }) =>
	({ fieldValue }) => {
		return fieldValue && !validFieldAsterisk(max)(fieldValue) ? msg : false;
	};

export const asteriskAfterThreeSymbols =
	({ msg }) =>
	({ fieldValue }) => {
		return fieldValue && !validFirstThreeLettersOfAsterisk(fieldValue) ? msg : false;
	};

export const yearValid =
	({ msg }) =>
	({ fieldValue }) => {
		return new RegExp('^[0-9]{4}$').test(fieldValue) ? false : msg;
	};

export const dayMonthValid =
	({ msg }) =>
	({ fieldValue }) => {
		return new RegExp('^(0[1-9]|[12][0-9]|3[01])[/.](0[1-9]|1[012])$').test(fieldValue) ? false : msg;
	};

export const dayMonthFromGreaterThanDayMonthTo =
	({ from, to, msg }) =>
	({ formData }) => {
		return isFirstDateGreater(formData[from], formData[to]) ? msg : false;
	};

export const compareFieldValues =
	({ from, to, msg }) =>
	({ formData }) => {
		return formData[from] && formData[to] && +formData[from] > +formData[to] ? msg : false;
	};

export const isValidCDV =
	({ msg }) =>
	({ fieldValue }) => {
		return checkCDV(Number(fieldValue)) ? false : msg;
	};
